import { render, staticRenderFns } from "./corSector.vue?vue&type=template&id=6296fa46&"
import script from "./corSector.vue?vue&type=script&lang=js&"
export * from "./corSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports